import { Person } from './person.entity';

export interface Face {
    Id: string;
    Embedding: string;
    BoundingBox: {
        Height: number;
        Width: number;
        TopLeftX: number;
        TopLeftY: number;
    };
    Person?: Person;
}

export function isFaceUpdated(original: Face, updated: Face): boolean {
    return (
        updated.Person?.RecordId !== original.Person?.RecordId ||
        updated.Person?.Name !== original.Person?.Name ||
        updated.Person?.NameChanged === true
    );
}
